<template>
  <div>
    <p class="title">推荐产品</p>
    <div class="recommend-product-wrapper">
      <div
        class="product-item"
        :style="{width:itemWidth+'px'}"
        v-if="!phone || allShow"
        @click="$router.push('/riskPhone')"
      >
        <img src="../../../assets/img/console/phone.png" alt="">
        <div class="title">手机号画像</div>
        <p class="info">1亿+风险手机号标签数据且每日新增10-20万，覆盖全球其中海外手机号总量4000万+。支持分钟级更新。</p>
      </div>
      <div
        class="product-item"
        :style="{width:itemWidth+'px'}"
        v-if="!ip || allShow"
        @click="$router.push('/riskIp')"
      >
        <img src="../../../assets/img/console/ip.png" alt="">
        <div class="title">风险IP画像</div>
        <p class="info">近1亿风险IP标签数据，每日20-30万新增数据；覆盖秒拨、代理及数据中心等IP池。支持秒级更新。</p>
      </div>
      <div
        class="product-item"
        :style="{width:itemWidth+'px'}"
        v-if="!platform || allShow"
        @click="$router.push('/riskMobile')"
      >
        <img src="../../../assets/img/console/platform.png" alt="">
        <div class="title">移动风险感知平台</div>
        <p class="info">在移动应用中植入风险感知SDK，在运行过程中采集信息与结合规则判定，实时检测出应用运行中的风险。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    itemWidth: {
      type: Number,
      default: 268
    },
    product: {
      type: Array,
      default () {
        return []
      }
    },
    allShow: {
      type: Boolean
    }
  },
  computed: {
    phone () {
      const arr = this.product.filter((item) => {
        return (item.busi === 'heika_online' || item.busi === 'heika_offline' || item.busi === 'heika_without_mainland_offline') && item.auditflag === '5'
      })
      return arr.length
    },
    ip () {
      const arr = this.product.filter((item) => {
        return (item.busi === 'blackipv2_online' || item.busi === 'blackipv2_offline') && item.auditflag === '5'
      })
      return arr.length
    },
    platform () {
      const arr = this.product.filter((item) => {
        return (item.busi === 'antifraud_online' || item.busi === 'antifraud_online') && item.auditflag === '5'
      })
      return arr.length
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 16px;
  font-weight: 500;
  color: rgba(29, 36, 60, 1);
  line-height: 30px;
  margin-bottom: 10px;
}
.recommend-product-wrapper {
  display: flex;
  flex-wrap: wrap;
  .product-item {
    height: 268px;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(244, 249, 255, 1) 100%
    );
    box-shadow: 4px 4px 8px 0px rgba(6, 22, 53, 0.06);
    border-radius: 4px;
    margin-right: 38px;
    margin-bottom: 32px;
    box-sizing: border-box;
    padding: 32px 24px;
    cursor: pointer;
    img {
      width: 91.35px;
      height: 87px;
      margin: 0 auto;
      display: block;
      margin-bottom: 18px;
    }
    .title {
      height: 30px;
      line-height: 30px;
      position: relative;
      font-size: 16px;
      font-weight: 500;
      color: rgba(29, 36, 60, 1);
      text-align: center;
      margin-bottom: 8px;
      &::before {
        content: '';
        position: absolute;
        top: 14.5px;
        left: -24px;
        width: 66px;
        height: 1px;
        background: linear-gradient(
          270deg,
          rgba(176, 251, 255, 1) 0%,
          rgba(41, 108, 255, 1) 100%
        );
      }
      &::after {
        content: '';
        position: absolute;
        top: 14.5px;
        right: -24px;
        width: 66px;
        height: 1px;
        background: linear-gradient(
          270deg,
          rgba(176, 251, 255, 1) 0%,
          rgba(41, 108, 255, 1) 100%
        );
      }
    }
    .info {
      font-size: 13px;
      font-weight: 400;
      color: rgba(29, 36, 60, 1);
      line-height: 22px;
    }
  }
}
</style>
